import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { DataService } from '../data.service';
import { Router } from '@angular/router';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-acep-pol-priv',
  templateUrl: './acep-pol-priv.component.html',
  styleUrls: ['./acep-pol-priv.component.css'],
    providers: [
      {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
      {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
      {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
    ] 
})
export class AcepPolPrivComponent implements OnInit {
  nombre: string = "";
  apellidos: string = "";
  nombreTut: string = "";
  apellidosTut: string = "";
  correo: string ="";
  chkDatos:boolean = false;
  chkPolitica:boolean = false;
  errMsg:string="";
  tiempoMsg:number = 3500;
  resultado:any;
  fechaIni = new Date(2000,0,1);
  fechaMax = new Date(2025,5,30);
  fecNac:any = moment();
  edad:number=999;

  thisForm = new FormGroup({
    nombre: new FormControl(this.nombre, [Validators.required, Validators.minLength(3)]),
    apellidos: new FormControl(this.apellidos, [Validators.required, Validators.minLength(5)]),
    correo: new FormControl(this.correo, [Validators.required, Validators.minLength(7)]),
    nombreTut: new FormControl(this.nombreTut, [Validators.minLength(3)]),
    apellidosTut: new FormControl(this.apellidosTut, [Validators.minLength(5)]),
    fecNac: new FormControl(this.fecNac, [Validators.required])
  })

  constructor(private dataService: DataService, private router:Router) { }

  ngOnInit() {
    //this.fechaLimite.setDate(this.fechaLimite.getFullYear() - 3)
  }

  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
      this.errMsg ="Caracter inválido!";
      setTimeout(() => {
        this.errMsg ="";        
      }, this.tiempoMsg);
      return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  fnCambiaFecha(tipo, ev){
    //console.log(ev);
    if(tipo=="NAC"){
      var auxFecNac = new Date(ev.value);
      this.fecNac = moment(auxFecNac);
      //console.log("Nacimiento: " + this.fecNac.format("YYYY MM DD"))
      var hoy = moment();
      this.edad = hoy.diff(this.fecNac, 'years');
    }
  }

  fnNavegar(pagina){
    if(pagina=="PRIVACIDAD")
      this.router.navigate(['avisoPriv']);
    if(pagina=="SERVICIO")
      this.router.navigate(['terminosServ']);
  }

  fnAceptaPolitica(){
    var aux = <HTMLInputElement>document.getElementById("chkAcepto");
    //console.log(aux.checked);        
    if(aux.checked)
      this.chkPolitica = true;
    else
      this.chkPolitica = false;
  }

  fnValidaDatos(){
    var aux = <HTMLInputElement>document.getElementById("chkProtesto");
    //console.log(aux.checked);
    if(aux.checked){
      if(this.thisForm.controls["nombre"].errors){
        this.thisForm.controls["nombre"].markAsDirty();
        this.thisForm.controls["nombre"].markAsTouched();
        if(this.thisForm.controls["nombre"].errors["required"])
          this.errMsg="Capture su 'Nombre'" + ". ";
        else
          this.errMsg="'Nombre' no válido" + ". " + this.thisForm.controls["nombre"].errors["minlength"].requiredLength + " caracteres mínimo.";
        aux.checked = false;
        setTimeout(() => {
          this.errMsg = "";
        }, this.tiempoMsg);
        return;
      }
      if(this.thisForm.controls["apellidos"].errors){
        this.thisForm.controls["apellidos"].markAsDirty();
        this.thisForm.controls["apellidos"].markAsTouched();
        if(this.thisForm.controls["apellidos"].errors["required"])
          this.errMsg="Capture sus 'Apellidos'" + ". ";
        else
          this.errMsg="'Apellidos' no válidos" + ". " + this.thisForm.controls["apellidos"].errors["minlength"].requiredLength + " caracteres mínimo.";
        aux.checked = false;
        setTimeout(() => {
          this.errMsg = "";
        }, this.tiempoMsg);
        return;
      }
      //console.log(this.edad)
      if(this.edad == 999 || this.edad <= 0){
        this.thisForm.controls["fecNac"].markAsDirty();
        this.thisForm.controls["fecNac"].markAsTouched();
        if(this.edad == 999)
          this.errMsg="Capture su 'Fecha de Nacimiento'" + ". ";
        else
          this.errMsg="'Fecha de Nacimiento' no válida" + ". " + ".";
        aux.checked = false;
        setTimeout(() => {
          this.errMsg = "";
        }, this.tiempoMsg);
        return;

      }
      if(this.edad < 18){
        if(this.thisForm.controls["nombreTut"].value == ""){
          this.thisForm.controls["nombreTut"].markAsDirty();
          this.thisForm.controls["nombreTut"].markAsTouched();
          if(this.thisForm.controls["nombreTut"].value == "")
            this.errMsg="Capture el 'Nombre de Padre / Tutor'" + ". ";
          aux.checked = false;
          setTimeout(() => {
            this.errMsg = "";
          }, this.tiempoMsg);
          return;
        }
        else{
          if(this.thisForm.controls["nombreTut"].value.length < 3){
            this.thisForm.controls["nombreTut"].markAsDirty();
            this.thisForm.controls["nombreTut"].markAsTouched();
            this.errMsg="'Nombre de Padre / Tutor'" + " no válido. 3 caracteres mínimo.";
            aux.checked = false;
            setTimeout(() => {
              this.errMsg = "";
            }, this.tiempoMsg);
            return;  
          }
        }
        if(this.thisForm.controls["apellidosTut"].value == ""){
          this.thisForm.controls["apellidosTut"].markAsDirty();
          this.thisForm.controls["apellidosTut"].markAsTouched();
          if(this.thisForm.controls["apellidosTut"].value == "")
            this.errMsg="Capture los 'Apellidos de Padre / Tutor'" + ". ";
          aux.checked = false;
          setTimeout(() => {
            this.errMsg = "";
          }, this.tiempoMsg);
          return;
        }
        else{
          if(this.thisForm.controls["apellidosTut"].value.length < 5){
            this.thisForm.controls["apellidosTut"].markAsDirty();
            this.thisForm.controls["apellidosTut"].markAsTouched();
            this.errMsg="'Nombre de Padre / Tutor'" + " no válido. 5 caracteres mínimo.";
            aux.checked = false;
            setTimeout(() => {
              this.errMsg = "";
            }, this.tiempoMsg);
            return;  
          }
        }
      }
      if(this.thisForm.controls["correo"].errors){
        this.thisForm.controls["correo"].markAsDirty();
        this.thisForm.controls["correo"].markAsTouched();
        if(this.thisForm.controls["correo"].errors["required"])
          this.errMsg="Capture su 'Correo electrónico'" + ". ";
        else
          this.errMsg="'Correo electrónico' no válido" + ". " + this.thisForm.controls["correo"].errors["minlength"].requiredLength + " caracteres mínimo.";
        aux.checked = false;
        setTimeout(() => {
          this.errMsg = "";
        }, this.tiempoMsg);
        return;
      }

      this.nombre = this.thisForm.controls["nombre"].value;
      this.apellidos = this.thisForm.controls["apellidos"].value;
      this.nombreTut = this.thisForm.controls["nombreTut"].value;
      this.apellidosTut = this.thisForm.controls["apellidosTut"].value;
      this.correo = this.thisForm.controls["correo"].value;
      this.chkDatos = true;
    }
    else
      this.chkDatos = false;
  }

  fnRegistrar(){
    //console.log("Registrar: " + this.nombre + "|" + this.apellidos + "|" + this.correo)
    this.dataService.insEvAudioIARegistro(this.nombre, this.apellidos, this.fecNac.format("YYYY/MM/DD"), this.nombreTut, this.apellidosTut, this.correo, null).subscribe(
                          rows => {   
                                  this.resultado = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnRegistrado());
  }

  fnRegistrado(){
    //console.log(this.resultado)
    this.thisForm.reset();
    this.edad = 999;
    var aux = <HTMLInputElement>document.getElementById("chkProtesto");
    aux.checked = false;
    this.chkDatos = false;
    var aux = <HTMLInputElement>document.getElementById("chkAcepto");
    aux.checked = false;
    this.chkPolitica = false;
    alert("Registro exitoso con folio \n\n" + "A-" + this.resultado);
  }

  fnPrueba(){
    this.dataService.cf_insEvAudioIARegistro(this.nombre, this.apellidos, this.fecNac.format("YYYY/MM/DD"), this.nombreTut, this.apellidosTut, this.correo, null).subscribe(
          rows => {   
                  this.resultado = <any>rows
                  },          
          error => this.errMsg = <any>error,
          () => this.fnTerminado());
  }

  fnTerminado(){
    console.log("fnTerminado()");
    console.log(this.resultado);
    alert (this.resultado);
  }

}
